<template>
<div class="box-labour">
    <div class="box-box">
        <div class="nav">
            <router-link to="HumanDirectory"><img src="../../assets/up.png" alt="" class="upClass"></router-link>
            工时制度
            <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
        </div>
        <div class="issueContent">
            <div>
                <p class="titleClass">1. 考勤管理</p>
                <img v-show="addShowJia" src="../../assets/jia.png" alt="" class="ImgClass" @click="addGetJia()">
                <img v-show="addShowXia" src="../../assets/xia.png" alt="" class="ImgClass" @click="addGetXia()">
            </div>
            <div v-for="item in dataList1" :key="item.id" v-show="showContent">
                <p class="titleClass titleCotent">{{item.title}}</p>
                <img src="../../assets/dian.png" alt="" class="ImgClass ImgClassDian" @click="addGetContent(item.id)">
            </div>
            <div>
                <p class="titleClass">2. 加班管理</p>
                <img src="../../assets/you.png" alt="" class="ImgClass" @click="addAgreement">
            </div>
            <div>
                <p class="titleClass">3. 休假制度</p>
                <img v-show="addShowJia1" src="../../assets/jia.png" alt="" class="ImgClass" @click="addGetJia1()">
                <img v-show="addShowXia1" src="../../assets/xia.png" alt="" class="ImgClass" @click="addGetXia1()">
            </div>
            <div v-for="(item, i) in dataList2" :key="i" v-show="showContent1">
                <p class="titleClass titleCotent">{{item.title}}</p>
                <img src="../../assets/dian.png" alt="" class="ImgClass ImgClassDian" @click="addGetContent1(i)">
            </div>
            <div>
                <p class="titleClass">4. 假勤申请及考勤确认</p>
                <!-- <img src="../../assets/you.png" alt="" class="ImgClass" @click="addAgreement2"> -->
                <img v-show="addShowJia2" src="../../assets/jia.png" alt="" class="ImgClass" @click="addGetJia2()">
                <img v-show="addShowXia2" src="../../assets/xia.png" alt="" class="ImgClass" @click="addGetXia2()">
            </div>
            <div v-for="item in dataList3" :key="item.age" v-show="showContent2">
                <p class="titleClass titleCotent">{{item.title}}</p>
                <img src="../../assets/dian.png" alt="" class="ImgClass ImgClassDian" @click="addGetContent2(item.age)">
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            addShowJia: true,
            addShowXia: false,
            showContent: false,
            addShowJia1: true,
            addShowXia1: false,
            showContent1: false,
            addShowJia2: true,
            addShowXia2: false,
            showContent2: false,
            dataList1: [{
                    title: "1.1 坐班指纹打卡",
                    id: "11"
                },
                {
                    title: "1.2 教师上课一卡通打卡",
                    id: "12"
                }
            ],
            dataList2: [{
                    title: "3.1 法定节假日(带薪休假期)"
                },
                {
                    title: "3.2 带薪年假"
                },
                {
                    title: "3.3 病假"
                },
                {
                    title: "3.4 婚假"
                },
                {
                    title: "3.5 丧假"
                },
                {
                    title: "3.6 产假"
                },
                {
                    title: "3.7 事假"
                }
            ],
            dataList3: [{
                    title: "4.1 EHR系统申请流程",
                    age: "221"
                },{
                    title: "4.2 云办公APP申请流程",
                    age: "222"
                }]
        };
    },
    methods: {
        addGetContent2(i){
            if(i == 221){
                this.$router.push({name:"ManpowerParticulars5"})
            } else if(i == 222) {
                this.$router.push({name:"ManpowerParticulars7"})
            }
        },
        getOnPage() {
            this.$router.push({
                name: 'Search',
                params: {
                    code: "555"
                }
            })
        },
        addGetJia() {
            this.addShowXia = true;
            this.showContent = true;
            this.addShowJia = false;
            if(this.addShowJia1 == false){
                this.addShowJia1 = true
                this.addShowXia1 = false
                this.showContent1 = false
            }
        },
        addGetXia() {
            this.addShowXia = false;
            this.showContent = false;
            this.addShowJia = true;
        },
        addGetJia1() {
            this.addShowXia1 = true;
            this.showContent1 = true;
            this.addShowJia1 = false;
            if(this.addShowXia == true){
                this.addShowJia = true
                this.addShowXia = false
                this.showContent = false
            }
        },
        addGetXia1() {
            this.addShowXia1 = false;
            this.showContent1 = false;
            this.addShowJia1 = true;
        },
        addGetJia2() {
            this.addShowXia2 = true;
            this.showContent2 = true;
            this.addShowJia2 = false;
            if(this.addShowXia == true){
                this.addShowJia = true
                this.addShowXia = false
                this.showContent = false
            }
        },
        addGetXia2() {
            this.addShowXia2 = false;
            this.showContent2 = false;
            this.addShowJia2 = true;
        },
        addGetContent(i) {
            if (i == 11) {
                this.$router.push({
                    name: 'ManpowerParticulars',
                    params: {
                        code: "11"
                    }
                });
            } else if (i == 12) {
                this.$router.push({
                    name: 'ManpowerParticulars1',
                params: {
                    code: "78"
                }});
            }
        },
        addAgreement() {
            this.$router.push({
                name: "ManpowerParticulars2"
            });
        },
        addGetContent1(i) {
            if(i == 0){
                this.$router.push({name:'ManpowerParticulars6'})
            } else if(i == 1){
                this.$router.push({name:'ManpowerParticulars3',params:{code:"1"}})
            } else if(i == 2){
                this.$router.push({name:'ManpowerParticulars3',params:{code:"2"}})
            } else if(i == 3){
                this.$router.push({name:'ManpowerParticulars3',params:{code:"3"}})
            } else if(i == 4){
                this.$router.push({name:'ManpowerParticulars3',params:{code:"4"}})
            } else if(i == 5){
                this.$router.push({name:'ManpowerParticulars4'})
            } else if(i == 6){
                this.$router.push({name:'ManpowerParticulars3',params:{code:"6"}})
            }
        },
        addAgreement2(){
            this.$router.push({name:'ManpowerParticulars5',params:{code:"7"}})
        }
    }
};
</script>

<style scoped>
.box-labour {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
}
.box-box {
    background: rgba(244, 244, 244, 1);
}
.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.issueContent {
    width: 90%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.3);
    border-radius: 10px;
    overflow: hidden;
}

.issueContent div {
    width: 100%;
    height: 56px;
    border-bottom: 1px solid #ededed;
}

.issueContent div:last-child {
    border-bottom: 0;
}

.issueContent div .titleClass {
    width: 86%;
    float: left;
    color: #838383;
    margin: 18px 0 18px 10px;
}

.issueContent div .ImgClassDian {
    width: 18px !important;
}

.issueContent div .titleCotent {
    width: 80% !important;
    margin-left: 24px !important;
    font-size: 15px;
}

.issueContent div img {
    width: 21px;
    float: right;
    margin: 18px 10px 18px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Manpower/manpower.vue